"use client";

import React, { useEffect, useRef, useState } from "react";
import CountUp from "react-countup";

const STATS = [
    { id: "recovered", value: 50, prefix: "₹", suffix: "+ Cr", label: "Recovered" },
    { id: "companies", value: 100, prefix: "", suffix: "+", label: "Companies Dealt" },
    { id: "clients", value: 50, prefix: "", suffix: "+", label: "Clients Served" },
];

export default function StatSection() {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setInView(true);
                observer.disconnect();
            }
        }, { threshold: 0.3 });

        if (ref.current) observer.observe(ref.current);
    }, []);

    return (
        <section
            ref={ref}
            className="py-10"
            style={{
                background: "var(--color-primary)",    // brand green background
            }}
        >
            <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-3 gap-8">
                {STATS.map((s, idx) => (
                    <div
                        key={s.id}
                        className="text-center"
                        style={{
                            background: "rgba(255, 255, 255, 0.06)",       // overlay
                            border: "1px solid rgba(255, 255, 255, 0.18)", // thin border
                            borderRadius: "22px",
                            padding: "1.4rem 1.5rem",
                            backdropFilter: "blur(4px)",
                            transform: inView ? "translateY(0)" : "translateY(10px)",
                            opacity: inView ? 1 : 0,
                            transition: `opacity 500ms ease ${idx * 100}ms, 
                           transform 500ms cubic-bezier(.25,.85,.35,1) ${idx * 100}ms`,
                        }}
                    >
                        {/* VALUE */}
                        <div
                            style={{
                                fontSize: "2.4rem",
                                fontWeight: 700,
                                color: "var(--bg-surface)",  // white text
                            }}
                        >
                            {s.prefix}
                            {inView ? (
                                <CountUp
                                    end={s.value}
                                    duration={1.6}
                                    separator=","
                                />
                            ) : (
                                0
                            )}
                            <span style={{ marginLeft: 6, fontSize: "0.7em" }}>{s.suffix}</span>
                        </div>

                        {/* LABEL */}
                        <div
                            style={{
                                marginTop: "10px",
                                fontSize: "1rem",
                                color: "rgba(255,255,255,0.92)",
                            }}
                        >
                            {s.label}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
